import { Howl } from 'howler';
import ObserverEmitter, { EVENTS } from '../emitter/Observer';
import { voicesTypeControl } from '../types/audioType';

let soundSceneChangue = {
	before: -1,
	after: -1
}
let volumeGlobal = {
	voice: 0.85,
	scene: 0.02,
	actionButton: 0.03
}

let isPause = false

//* Scene --
let soundSceneHowl = null
let isPlayScene = false

const createSoundScene = (sceneSound = "") => {
	let isBeforeExist = false

	if (soundSceneHowl) {
		isBeforeExist = true
		soundSceneHowl.stop()
	}

	if (sceneSound === "") {
		return
	}
	soundSceneHowl = new Howl({
		src: [sceneSound],
		loop: true,
	});
	// soundSceneHowl
	soundSceneChangue.before++
	if (isBeforeExist) {
		playSceneSound()
	}
}

const playSceneSound = () => {
	if (isPause) {
		return
	}
	if (!soundSceneHowl) {
		return
	}
	if (soundSceneChangue.before === soundSceneChangue.after) {
		return
	}
	isPlayScene = true
	soundSceneChangue.after++
	soundSceneHowl.volume(volumeGlobal.scene)
	soundSceneHowl.stop()
	soundSceneHowl.play()
}

//* Scene Final--

//* Acciones --
const createSounActionButton = (asset = "") => {
	if (isPause) {
		return
	}
	const soundActionButtonHowl = new Howl({
		src: [asset],
	});
	soundActionButtonHowl.volume(volumeGlobal.actionButton)
	soundActionButtonHowl.play()
}
//* Acciones Final --

//* Pause --
const togglePause = () => {
	if (!isPlayScene) {
		return
	}
	isPause = !isPause
	ObserverEmitter.emit(EVENTS.audiosEvents.pauseListen, isPause);
	if (isPause) {
		soundSceneHowl.volume(0)
	} else {
		soundSceneHowl.volume(volumeGlobal.scene)
	}
}
//* Pause Final --


//* Voces --
let soundVoiceButtonHowl = null
let isPlayVoice = false
const createSoundVoice = (asset = "") => {
	if (isPause) {
		return
	}
	if (isPlayVoice) {
		soundVoiceButtonHowl.stop()
	}

	soundVoiceButtonHowl = new Howl({
		src: [asset],
	});

	soundVoiceButtonHowl.volume(volumeGlobal.voice)
	soundVoiceButtonHowl.play()
	isPlayVoice = true
}

const controVoices = (type = voicesTypeControl.stop) => {
	if (isPause) {
		return
	}
	if (voicesTypeControl.stop === type) {
		isPlayVoice = false
		soundVoiceButtonHowl.stop()
	}
}

//* Voces Final --

ObserverEmitter.on(EVENTS.audiosEvents.createAudioVoiceButton, (soundAsset = "") => {
	createSoundVoice(soundAsset)
});


ObserverEmitter.on(EVENTS.audiosEvents.controlVoices, (type = voicesTypeControl.stop) => {
	controVoices(type)
});


ObserverEmitter.on(EVENTS.audiosEvents.createAudioActionButton, (soundAsset = "") => {
	createSounActionButton(soundAsset)
});

ObserverEmitter.on(EVENTS.audiosEvents.createAudioScene, (soundAsset = "") => {
	createSoundScene(soundAsset)
});

ObserverEmitter.on(EVENTS.audiosEvents.pauseActive, (isVerification = false) => {
	if (isVerification) {
		ObserverEmitter.emit(EVENTS.audiosEvents.pauseListen, isPause);
		return
	}
	togglePause()
});

document.addEventListener('click', function (event) {
	playSceneSound()
});

export const initInstace = () => { }
